'use client';

import Image from 'next/image';

const ForAndBySeniorsImagePath = '/images/ForAndBySeniors/ForAndBySeniors.webp';

const Block1 = () => (
  <div className="bg-policeblue-dark md:gap-4 rounded-lg shadow-lg md:flex-row flex h-full w-full flex-col items-center justify-between">
    <div className="gap-4 p-4 md:w-7/12 md:p-6 lg:p-8 flex h-full w-full flex-col">
      <h3 className="text-stonerwhite">La valorisation du parcours et des compétences</h3>

      <p className="text-verylightgrey text-justify">
        Chaque participant apportera son CV et expliquera sa réflexion de rédaction.
      </p>

      <p className="text-verylightgrey text-justify">
        Les CV anonymisés seront ensuite analysés en groupe selon une approche miroir.
      </p>

      <p className="text-verylightgrey text-justify">
        En se plaçant dans la posture d&apos;un recruteur, les membres du groupe apporteront un
        regard constructif sur la pertinence et l&apos;impact des présentations.
      </p>
    </div>

    <div className="bg-policeblue-dark rounded-lg shadow-lg md:w-5/12 p-4 h-full w-full">
      <Image
        src={`${ForAndBySeniorsImagePath || ''}`}
        alt="Seniors interacting in a talk group"
        className="rounded-lg h-full w-full"
        width={1920}
        height={1440}
      />
    </div>
  </div>
);

const Block2 = () => (
  <div className="gap-4 md:flex-row flex flex-col">
    <div className="bg-policeblue-dark gap-4 rounded-lg p-4 md:p-6 lg:p-8 flex flex-1 flex-col">
      <h3 className="text-stonerwhite">
        Les retours d&apos;expérience en matière de recherche d&apos;emploi
      </h3>

      <p className="text-verylightgrey text-justify">
        Les participants partageront les enseignements tirés de leur propre parcours, analyseront
        les défis communs et identifieront ensemble les solutions possibles.
      </p>
    </div>

    <div className="bg-policeblue-dark gap-4 rounded-lg p-4 md:p-6 lg:p-8 flex flex-1 flex-col">
      <h3 className="text-stonerwhite">Leur expérience des entretiens d&apos;embauche</h3>

      <p className="text-verylightgrey text-justify">
        Le groupe bénéficiera d&apos;un espace de parole pour exprimer ses appréhensions, analyser
        les bonnes pratiques et confronter les vécus.
      </p>
    </div>
  </div>
);

const Block3 = () => (
  <div className="bg-policeblue-dark space-y-4 rounded-lg p-4 md:p-6 lg:p-8">
    <h3 className="text-stonerwhite text-justify">Ces ateliers</h3>

    <h4 className="text-stonerwhite text-justify">
      Conçus comme des <span className="text-orange">espaces d&apos;échange authentiques</span>,
      renforceront à la fois :
      <ul className="text-sm list-inside list-disc">
        <li>
          la <span className="text-orange">confiance</span> des participants
        </li>
        <li>
          leur capacité à <span className="text-orange">se projeter</span>
        </li>
        <li>
          leur <span className="text-orange">réseau</span>
        </li>
      </ul>
    </h4>

    <h4 className="text-stonerwhite text-justify">
      Ils s&apos;appuieront sur la richesse de{' '}
      <span className="text-orange">l&apos;expérience collective</span> pour offrir des leviers
      concrets vers leur prochain poste.
    </h4>
  </div>
);

const ForAndBySeniors = () => (
  <section className="bg-stonerwhite p-4 sm:p-8 md:p-10 lg:p-12 flex justify-center">
    <div className="space-y-4 md:flex-row max-w-6xl m-auto">
      <div className="mx-auto w-full">
        <div className="space-y-4 md:space-y-6 lg:space-y-8">
          <div className="space-y-4 flex flex-col items-center">
            <h2 className="text-policeblue-dark font-bold">
              Des ateliers pour et par les talents de 45&nbsp;ans et plus
            </h2>

            <p className="text-charcoal font-semibold text-justify">
              Dans notre démarche d&apos;accompagnement, nous proposerons des ateliers, coanimés
              avec des talents de 45&nbsp;ans et plus.
            </p>

            <p className="text-charcoal font-semibold text-justify">
              Ces sessions favoriseront les échanges d&apos;expériences et de savoir-faire autour de
              thématiques stratégiques telles que :
            </p>
          </div>

          <Block1 />
          <Block2 />
          <Block3 />
        </div>
      </div>
    </div>
  </section>
);

export default ForAndBySeniors;
